<template>
  <div id="events" class="content container">

    <h3>Car Shows &amp; Events</h3>

    <!-- If data loading fails -->
    <div v-if="events.length === 0" id="error" class="alert alert-warning">
      Sorry, but there was a problem loading the events. Please try again later.
    </div>

    <!-- Success! -->
    <div v-else id="success">
      <p>All car shows and club events are listed with the most recent at top.</p>

      <div class="accordion" id="eventsAccordion">
        <div v-for="(event, index) in events" :key="index">

          <div class="card">
            <div class="card-header" :id="`GR_event_heading_${index}`">
              <h2 class="mb-0">
                <button class="btn btn-link" type="button" data-toggle="collapse" :data-target="`#GR_event_${index}`"
                  aria-expanded="true" :aria-controls="`GR_event_${index}`">
                  {{ event.title }}
                </button>
              </h2>
            </div>

            <div :id="`GR_event_${index}`" :class="getClass(index)" data-parent="#eventsAccordion">
              <div class="card-body">
                <h4>Show Date: {{ event.timing }}</h4>

                <div v-if="event.hasOwnProperty('update') && event.update.level && event.update.text">
                  <div :class="`alert alert-${event.update.level}`">
                    {{ event.update.text }}
                  </div>
                </div>

                <p v-for="(descElement, index1) in event.description" :key="index1"> {{ descElement }} </p>
                
                <div class="alert alert-info">
                  <h6>Details:</h6>
                  <ul>
                    <li>Show Starts at {{ event.showStart }}</li>
                    <li>
                      Registration:
                      ${{ event.registrationPrice }}
                      &mdash; 
                      begins at
                      {{ event.registrationStartTime }}
                    </li>
                    <li>Trophies at {{ event.trophyTime }}</li>
                    <li v-show="event.flyerLink">
                      <a :href="event.flyerLink" target="_blank">View/Download the flyer</a>
                    </li>
                  </ul>
                </div>
                <div class="alert alert-dark indent">
                  <h6>Location:</h6>
                  <ul>
                    <li>{{ event.location }}</li>
                    <li v-show="event.mapLink">
                      <a :href="event.mapLink" target="_blank">View on interactive map</a>
                    </li>
                  </ul>
                </div>
                <div v-if="event.registerLink" class="alert alert-success">
                  <h6>Preregistration</h6>
                  <p>
                    You may preregister for this show online. Payment will be collected in person, the day of the show.
                    As always, you may also choose to register and pay the day of.
                  </p>
                  <router-link :to="{ name: 'Register', params: { id: event.registerLink }}">Register Now</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EventsView',
  data() {
    return {
        events: []
    }
  },
  methods: {
    ...mapActions(['getEventsJson']),
    getClass(index) {
      return (index === 0) ? 'collapse show' : 'collapse'
    } 
  },
  computed: {
    ...mapGetters(['isEventsJsonLoadedGetter', 'eventsJsonGetter'])
  },
  async created() {
    if (!this.isEventsJsonLoadedGetter) {
      await this.getEventsJson()
    }
    this.events = this.eventsJsonGetter
  }
}
</script>

<style scoped>
#events h6 {
  font-weight: bold;
}
</style>
